import { createIcon } from "@chakra-ui/react";

const HomeIcon = createIcon({
  displayName: "HomeIcon",
  viewBox: "0 0 24 24",
  path: <path d="M10 20v-6h4v6h5v-8h3L12 3L2 12h3v8z" fill="currentColor" />,
});

export default HomeIcon;
